import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@features/receipts/receipts.module').then(
        (m) => m.ReceiptsModule
      ),
  },
  {
    path: 'sample',
    loadChildren: () =>
      import('@features/sample/sample.module').then((m) => m.SampleModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
